import axios from 'axios';
import { updateContext } from '../../contactUs/actions/action-article';
import { fetchFinalTopicContent } from '../../contactUs/actions/action-select-topic';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import { returnRefIDforIntentCode, returnRefIdEnabledPrompts } from '../../lib/omnichannelHelper';
import { getSearchResult } from '../../lib/crawlSearchHelper';
import { postChatBotEligibility } from '../../contactUs/actions';
import {
  RECEIVED_OCP_DATA, RESET_OMNI_CHANNEL_PROMPT_INFO, OCP_PROMPT_CLICKED,
} from '../commonActionTypes';
import Page from '../../lib/page';

export function receivedOCPData(data) {
  return {
    type: RECEIVED_OCP_DATA,
    payload: data,
  };
}

export const resetOCPData = () => ({
  type: RESET_OMNI_CHANNEL_PROMPT_INFO,
});

const ocpClicked = () => ({
  type: OCP_PROMPT_CLICKED,
});

/**
 * Get Topic RefId from Intent Code,
 * Get Topic  Details from searchPool for the current topic refID,
 * Fetch final Intent for the topic ID,
 * Reset the OCP properties,
 * @param {*} intentArticles
 * @param {*} intentCode
 * @param {*} searchPool
 */
export const loadOcpFinalIntent = (intentArticles, intentCode, searchPool) => (dispatch) => {
  dispatch(ocpClicked());
  trackLink({ id: 'contactUsOmniChannelPromptClicked', link: `smarthelp-ocp-prompt-clicked|${intentCode}` });
  const articleRefId = returnRefIDforIntentCode(intentCode);
  const topicDetails = getSearchResult({ searchPool, query: articleRefId });

  if (topicDetails) {
    // This line chooses the ref id if the intent_code is associated with ref id in remote config
    const intentIndex = topicDetails.findIndex((e) => e.intent_code === returnRefIdEnabledPrompts(e.ref_id)) || 0;
    const topic = {
      topicId: topicDetails[intentIndex].topic_id,
      topicName: topicDetails[intentIndex].topic_name,
      topicRefId: articleRefId,
    };
    updateContext(intentArticles, '', true);
    dispatch(fetchFinalTopicContent({ topic }));
    const postChatBotResponse = Page.getChatBotEligibilityParams(articleRefId, 'TOPIC');
    dispatch(postChatBotEligibility(postChatBotResponse));
    dispatch(resetOCPData());
  } else {
    trackPage({ id: 'contactUsOmniChannelPromptFinalIntentRedirectError' });
    dispatch(resetOCPData());
  }
};

export const doServerSideFptiCall = (intentArticles) => axios.post('/smarthelp/server-side-fpti', { intentArticles, _csrf: Page.getCSRFtoken() })
  .then(() => null)
  .catch(() => null);
